/* eslint-disable react/jsx-pascal-case */
import styles from "./interviewCard.module.scss";
import passBackgroundCard from "../../../assets/images/pass-background-with-card-1@2x.png";
import avatarProfilePic from "../../../assets/images/avatar-profile-picture.svg";
import taizoinLogoWatermarkIcon from "../../../assets/images/taizoin-logo-watermark.svg";
import html2canvas from "html2canvas";
import React, { useEffect, useRef, useState } from "react";
import { GetInterviewDetails, sendInterviewScheduleEmail } from "../../../apiServices";
import { DDMMYYYY_formate, DMMMYYYY_formate, MyModal } from "../../../utility";
import SuccessTick from "../../../components/success_tick";
import ModalContainer from "../../../components/modal_popup";

const CandidateInterviewCard = ({ interviewId, CandidateInterviewCard }) => {
  const elementRef = useRef(null);
  const [interviewDetails, setInterviewDetails] = useState({});
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    GetInterviewDetails(interviewId).then((res) => {
      setInterviewDetails({
        candidateId: res.candidate.id,
        adminid:res.candidate.assignTo,
        candidateName: res.candidate.firstName,
        candidateLastName: res.candidate.lastName!=null?res.candidate.lastName:"",
        companyName: res.job.companyName,
        position:
          res.interview.interviewJobCategory != null
            ? res.interview.interviewJobCategory
            : res.job.jobCategory,
        contactPersonName: res.interview.contactPersonName,
        interviewScheduledDt: res.interview.interviewScheduledDt,
        interviewDate: res.interview.interviewDate,
        interviewTime: res.interview.interviewTime,
        jobId: res.interview.jobId,
        emailId: res.candidate.emailId,
        location: res.interview.area + " - " + res.interview.city
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadInterviewCard = async () => {
    try {
      if (!elementRef.current) return;

      const canvas = await html2canvas(elementRef.current, {
        backgroundColor: "#ffffff",
        scale: 0.7,
      });

      const image = canvas.toDataURL("image/png");

      const candidateName = interviewDetails.candidateName.trim();

      const link = document.createElement("a");
      link.href = image;
      link.download = `${candidateName}_InterviewCard.png`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  };
const sendInterviewAlert = async () => {

  if (sending) return;

  setSending(true);

  try {

    if (!elementRef.current) return;

    const canvas = await html2canvas(elementRef.current, {
      backgroundColor: "#ffffff",
      scale: 0.7
    });

    const imageData = canvas.toDataURL("image/png");

    const payload = {
      companyName: interviewDetails.companyName,
      interviewLocation: interviewDetails.location,
      interviewDate: interviewDetails.interviewDate,
      interviewTime: interviewDetails.interviewTime,
      candidateName: interviewDetails.candidateName,
      adminid: interviewDetails.adminid,
      jobid: interviewDetails.jobId,
      emailid: interviewDetails.emailId,
      candidateid: interviewDetails.candidateId,
      cc: "",
      bcc: "",
      interviewCardImage: imageData
    };

    const data = await sendInterviewScheduleEmail(payload);

    console.log("Email Response:", data);

    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
    }, 3000);

  } catch (error) {

    console.error("Server Error:", error);

    if (error?.message === "Missing required parameters") {
      alert("❌ Email Id is missing");
      return;
    }

    alert("❌ Interview Alert Failed - contact IT support");

  } finally {
    setSending(false);
  }

};
  // const sendInterviewAlert = async () => {
  //   if (sending) return; // prevent multiple clicks

  //   setSending(true);

  //   try {
  //     if (!elementRef.current) return;

  //     const canvas = await html2canvas(elementRef.current, {
  //       backgroundColor: "#ffffff",
  //       scale: 0.7,
  //     });

  //     const imageData = canvas.toDataURL("image/png");

  //     const payload = {
  //       companyName: interviewDetails.companyName,
  //       interviewLocation: interviewDetails.location,
  //       interviewDate: interviewDetails.interviewDate,
  //       interviewTime: interviewDetails.interviewTime,
  //       candidateName: interviewDetails.candidateName,
  //       adminid: interviewDetails.adminid,
  //       jobid: interviewDetails.jobId,
  //       emailid: interviewDetails.emailId,
  //       candidateid: interviewDetails.candidateId,
  //       cc: "",
  //       bcc: "",
  //       interviewCardImage: imageData,
  //     };

  //     const res = await fetch(
  //       "http://localhost:3001/sendInterviewScheduleEmail",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       },
  //     );

  //     if (!res.ok) {
  //       let errorData = {};

  //       try {
  //         errorData = await res.json();
  //       } catch (err) {
  //         console.error("Error parsing response");
  //       }

  //       console.error("Server Error:", errorData);

  //       if (errorData?.message === "Missing required parameters") {
  //         alert("❌ Email Id is missing");
  //         return;
  //       }

  //       alert("❌ Interview Alert Failed - contact IT support");
  //     }

  //     const data = await res.json();

  //     console.log("Email Response:", data);

  //     // alert("✅ Interview Alert Sent Successfully");
  //     setSuccess(true);
  //     setTimeout(() => {
  //       setSuccess(false);
  //     }, 3000);
  //   } catch (error) {
  //     console.error("Email send error:", error);
  //     alert("❌ Failed to send interview alert");
  //   } finally {
  //     setSending(false); // enable button again
  //   }
  // };
  return (
    <div
      className={`${styles.taizoinCandidateInterviewC} ${styles.fontPoppins} `}
    >
      <div ref={elementRef} className={styles.taizoinInterviewCardpassB}>
        <img
          className={styles.passBackgroundWithCard1}
          alt=""
          src={passBackgroundCard}
        />
        <div className={styles.nterviewCardpass}>
          <div className={styles.cardDetailsDiv}>
            <div className={styles.cardDetails}>
              <h1 className={styles.interviewCard}>INTERVIEW CARD</h1>
              <img
                className={styles.avatarProfilePictureIcon}
                loading="eager"
                alt=""
                src={avatarProfilePic}
              />
              <img
                className={styles.taizoinLogoWatermarkIcon}
                alt=""
                src={taizoinLogoWatermarkIcon}
              />
              <div className={styles.cardDetailWrp}>
                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    Full name{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    : {interviewDetails.candidateName}{" "}
                  </div>
                </div>
                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    Company Name{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    : {interviewDetails.companyName}{" "}
                  </div>
                </div>
                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    Position{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    : {interviewDetails.position}{" "}
                  </div>
                </div>
                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    To Meet{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    : {interviewDetails.contactPersonName}{" "}
                  </div>
                </div>
                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    Reason{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    : Interview{" "}
                  </div>
                </div>
                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    Date{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    :{" "}
                    <DMMMYYYY_formate
                      dateValue={interviewDetails.interviewDate}
                    />{" "}
                  </div>
                </div>

                <div className="row ps-3">
                  <div className={`${styles.fontPoppins} col-5 ps-4`}>
                    Time{" "}
                  </div>
                  <div className={`${styles.fontPoppins} col-7`}>
                    : {interviewDetails.interviewTime}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.note}>
              <div className={`${styles.note1} ${styles.fontPoppins}`}>
                Note:
              </div>
              <div
                className={`${styles.thisDigitalInterview} ${styles.fontPoppins}`}
              >
                This digital interview card is only for interview purpose and
                valid only one day from the date of interview.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center gap-2 justify-content-between mt-3">
        <button
          onClick={downloadInterviewCard}
          className={styles.sendWhatsappButton}
        >
          <div className={styles.sendWhatsapp}>Download Card</div>
        </button>

        <button
          onClick={sendInterviewAlert}
          disabled={sending}
          className={styles.sendWhatsappButton}
        >
          <div className={styles.sendWhatsapp}>
            {sending ? "Sending..." : "Send Interview"}
          </div>
        </button>
      </div>
      {success && (
        <MyModal>
          <ModalContainer
            zIndex={1000}
            childComponent={<SuccessTick HeadText="Successfully" />}
          />
        </MyModal>
      )}
    </div>
  );
};

export default CandidateInterviewCard;
